import { ShellContainerConfig } from '@appd/fso-ui-shell/container';
import { FEATURE_FLAGS_STORE_KEY } from '../core/constants';
import * as FLAG_DEFINITIONS from './FLAG_DEFINITIONS';

export const getShellFeatureFlagsConfig = (): ShellContainerConfig => {
  return {
    featureFlags: {
      flagsConfig: {
        flagsStoreKey: FEATURE_FLAGS_STORE_KEY,
        flagDefinitions: FLAG_DEFINITIONS,
      },
    },
  };
};
